import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ChangePasswordService } from './change-password.service';
import { ToastrService } from 'ngx-toastr';
import { CryptoService } from 'src/app/shared/crypto/crypto.service';
import { ConfirmationDialogService } from 'src/app/shared/confirmation-dialog/confirmation-dialog.service';
import { MENU } from 'src/app/layouts/sidebar/menu';
import { Menu, pBMenus } from 'src/app/shared/all-routes';
import { HttpService } from 'src/app/shared/http.service';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RegistrationValidator } from '../profile/confirmValidator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  id: number | undefined;
  changePasswordForm: FormGroup | undefined;
  form: FormGroup | undefined;
  data: any = {};
  isUpdating: boolean | number = false;
  submitted = false;
  ICON_CHECK = "fa fa-check";
  ICON_TIMES = "fa fa-times";

// Character sets
  UPPER_CASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  LOWER_CASE = "abcdefghijklmnopqrstuvwxyz";
  SPECIAL_CHARACTERS = "!@#$%^&*()-=_+[]{}|;:'\",.<>/?";
  NUMBERS = "0123456789";
  icon_total_charecter: string = "fa fa-times";
  icon_spectial_charecter: string = "fa fa-times";
  icon_upper: string = "fa fa-times";
  icon_lower: string = "fa fa-times";
  icon_number: string = "fa fa-times";
  show: boolean = false;
  showPassword: boolean = false;
  showConfPassword: boolean = false;
  ptext: string = "show";
  ptype: string = "password";
  cptype: string = "password";;
  cptext: string = "show";
  appInfo: any = {};
  queryParams: any = {};
  ordering: any = [];
  menu: any = [];
  permissions: any;
  pBRoutes: Menu | undefined = pBMenus.find(x => x.id == "ChangePassword");
  inputChangeVal : any
  passwordRules = [
  { label: '8 characters', check: (pwd: string) => pwd.length >= 8 },
  { label: '1 uppercase', check: (pwd: string) => /[A-Z]/.test(pwd) },
  { label: '1 lowercase', check: (pwd: string) => /[a-z]/.test(pwd) },
  { label: '1 number', check: (pwd: string) => /\d/.test(pwd) },
  { label: '1 special character', check: (pwd: string) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd) }
];
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private route: ActivatedRoute,
    private changePasswordService: ChangePasswordService,
    private confirmationDialogService: ConfirmationDialogService,
    private cryptoService: CryptoService,
    private toastr: ToastrService,
    private httpService: HttpService,
    fb: FormBuilder,
    private formBuilder: FormBuilder,
  ) {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confPassword: ['', Validators.required]
    }, {
        validator: RegistrationValidator.validate.bind(this)
      });
      this.form = this.changePasswordForm;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
  }

  containsSpecialCharacter(): boolean {
    return this.passwordMeetsCriteria('[!@#$%^&*()_+={};:<>|,./?]');
  }

  passwordMeetsCriteria(criteria: string): boolean {
    const newPassword = this.data.NewPassword;
    if (criteria === '8chars') {
      return !!newPassword && newPassword.length >= 8;
    } else {
      const regex = new RegExp(criteria);
      return !!newPassword && regex.test(newPassword);
    }
  }


  ngOnInit() {
    let that = this;
    var count = 0;
    let menus = that.httpService.menus();
    let filteredMenus = menus.filter((x: { AccessTypeId: null; }) => x.AccessTypeId != null);
    that.permissions = filteredMenus.map((x: { Id: any; }) => x.Id);
    for (var i = 0; i < MENU.length; i++) {
      if (MENU[i].link == '') {
        for (var j = 0; j < MENU[i].permissions.length; j++) {
          that.ordering[count] = MENU[i].permissions[j];
          that.menu.push(MENU[i].subItems[j]);
          count++;
        }
      }
      else {
        that.ordering[count] = MENU[i].permissions[0];
        that.menu.push(MENU[i]);
        count++;
      }
    }
    that.appInfo = that.httpService.getAppInfo(-1);
    let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    that.queryParams.id = currentUser.user.Id;
  }

  submit(valid: boolean) {
    let that = this;
    that.submitted = true;
    if (valid && !that.appInfo.isUserReadonly) {
      that.isUpdating = true;
      that.queryParams.id ? that.update() : that.toastr.error('Something went wrong. Please logout and try again.');
    }
    else {
      valid == true ? that.toastr.error('You cannot save your changes') : "";
    }
  }

  update() {
    let that = this;

    that.httpService
      .put(that.pBRoutes?.api + that.queryParams.id, that.data)
      .subscribe((res: any) => {
        that.reloadForm('Password has been updated successfully!');
      }, (err: any) => {
        that.toastr.error(err?.error?.Message);
      });
    that.isUpdating = false;
  }
getPasswordChecks() {
  return this.passwordRules.map(rule => ({
    label: rule.label,
    passed: rule.check(this.data.NewPassword || '')
  }));
}
  reloadForm(message?: string) {
    let that = this;
    if (message) {
      that.toastr.success(message);
    }
    that.activeModal.dismiss('Cross click');
  }

  showList() {
  this.show = true;
}

hideList() {
  this.show = false;
}


  inputChange(event: any) {
    const inputValue: string = event;
    this.inputChangeVal = inputValue;
  
    if (this.inputChangeVal) {
      this.icon_total_charecter = this.inputChangeVal.length >= 8 ? this.ICON_CHECK : this.ICON_TIMES;
      this.icon_upper = this.countContain(this.inputChangeVal, this.UPPER_CASE) >= 1 ? this.ICON_CHECK : this.ICON_TIMES;
      this.icon_lower = this.countContain(this.inputChangeVal, this.LOWER_CASE) >= 1 ? this.ICON_CHECK : this.ICON_TIMES;
      this.icon_spectial_charecter = this.countContain(this.inputChangeVal, this.SPECIAL_CHARACTERS) >= 1 ? this.ICON_CHECK : this.ICON_TIMES;
      this.icon_number = this.countContain(this.inputChangeVal, this.NUMBERS) >= 1 ? this.ICON_CHECK : this.ICON_TIMES;
    } else {
      // Reset icons and ConfirmPassword
      this.resetIcons();
    }
  }
  
  resetIcons() {
    this.icon_total_charecter = this.ICON_TIMES;
    this.icon_number = this.ICON_TIMES;
    this.icon_spectial_charecter = this.ICON_TIMES;
    this.icon_lower = this.ICON_TIMES;
    this.icon_upper = this.ICON_TIMES;
    this.data.ConfirmPassword = '';
  }
  
  countContain(strPassword: string, strCheck: string) {
    return strPassword.split('').filter(char => strCheck.includes(char)).length;
  }

  showHidePassword() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.ptype = "text";
      this.ptext = "hide";
    }
    else {
      this.ptype = "password";
      this.ptext = "show";
    }
  }

  showHideConfPassword() {
      this.showConfPassword = !this.showConfPassword;
      if (this.showConfPassword) {
      this.cptype = "text";
      this.cptext = "hide";
    }
    else {
      this.cptype = "password";
      this.cptext = "show";
    }
  }

}
